import client from './client';

export const getLotsPaginated = (params) =>
  client.get('/inventory-lots', { params }).then((r) => r.data);

export const getLotsByProduct = (productUuid) =>
  client.get(`/inventory-lots/by-product/${productUuid}`).then((r) => r.data);

export const getLot = (uuid) =>
  client.get(`/inventory-lots/${uuid}`).then((r) => r.data);

export const getExpiringLotsPaginated = (params) =>
  client.get('/inventory-lots/expiring', { params }).then((r) => r.data);

export const getExpiredLotsPaginated = (params) =>
  client.get('/inventory-lots/expired', { params }).then((r) => r.data);
